import { datas } from '@/assets/utils/qurban';
import QurbanService from '@/services/qurban';
import TransactionService from '@/services/transaction';

export default {
    getData({commit}, params) {
        return new Promise((resolve, reject) => {
            QurbanService.getData({
                params,
                headers: {
                    'Authorization': localStorage.token
                }
            })
            .then(qurban => {
                commit('SET_DATA_QURBAN', qurban.data);
                resolve(qurban.data.data);
            })
            .catch(e => reject(e));
        });
    },
    getDetail({state}, id) {
        let qurban = state.qurbans.find(it => it.id == id);

        if(!qurban) {
            qurban = state.otherQurbans.find(it => it.id == id);
        }

        if(!qurban) {
            return new Promise((resolve, reject) => {
                QurbanService.getDetail(id, {
                    params: {},
                    headers: {
                        'Authorization': localStorage.token
                    }
                })
                .then(response => resolve(response.data))
                .catch(e => reject(e));
            });
        }
        else {
            return Promise.resolve(qurban)
        }
    },
    getOtherQurban({commit}, params) {
        return new Promise((resolve, reject) => {
            QurbanService.getData({
                params,
                headers: {
                    'Authorization': localStorage.token
                }
            })
            .then(qurban => {
                commit('SET_DATA_OTHER', qurban.data.data);
                resolve();
            })
            .catch(e => reject(e));
        });
    },
    setTransactionProduct({commit}, payload) {
        commit('SET_TRANSACTION_PRODUCT', payload)
    },
    setTransactionPayment({commit}, payload) {
        commit('SET_TRANSACTION_PAYMENT', payload)
    },
    setTransactionHistory({commit}, payload) {
        commit('SET_TRANSACTION_HISTORY', payload)
    },
    removeTransactionProduct({commit}) {
        commit('REMOVE_TRANSACTION_PRODUCT')
    },
    removeTransactionPayment({commit}) {
        commit('REMOVE_TRANSACTION_PAYMENT')
    },
    removeTransactionHistory({commit}) {
        commit('REMOVE_TRANSACTION_HISTORY')
    },
    makeTransaction ({commit}, payload = {}) {
        return new Promise((resolve, reject) => {
            TransactionService.makeTransaction(payload, {
                headers: {
                    'Authorization': localStorage.token
                }
            })
            .then(response => {
                commit('SET_TRANSACTION_HISTORY', response.data);
                resolve(response.data);
            })
            .catch(e => reject(e));
        });
    },
    getTrackingCode({state}) {
        return state.track.kode;
    },
    setTrackingCode({commit}, kode) {
        commit('SET_TRACKING_CODE', kode);
    },
    removeTrackingCode({commit}) {
        commit('REMOVE_TRACKING_CODE');
    },
    getTrackingResult({commit, state}) {
        return new Promise((resolve, reject) => {
            const params = {
                kode: state.track.kode
            };

            QurbanService.getTrackingResult({
                params,
                headers: {
                    'Authorization': localStorage.token
                }
            })
            .then(response => {
                const result = response.data ? response.data : null;
                commit('SET_TRACKING_DATA', result);
                resolve();
            })
            .catch(e => reject(e));
        });
    }
};